<template>
  <div>
    <div class="modal modal--login "
         id="login_modal">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__header modal_ti_header">
        </div>
        <div class="modal__body">
          <img class="modal_icon_alert"
               src="static/images/icon-info-XL.svg" />
          <p>{{ getTranslations.home_login_modal_text1 }}</p>
          <p>{{ getTranslations.home_login_modal_text2 }}
            <router-link :to="'forgotPassword1'">
            {{ getTranslations.home_login_modal_text3 }}
            </router-link>
          </p>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'login-modal',
  created() {
    this.showModal();
  },
  methods: {
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#login_modal').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/LoginModal.vue